let configSettings = require('../../static/config.json');
import axios from 'axios';
import  authService  from '@/services/authService';
export default {
  baseUrl:null,
  requestHeaders:null,
  initHttpSettings(actionPrefix){
    let _self=this;
    actionPrefix=actionPrefix?actionPrefix+'/':'';
    _self.baseUrl =configSettings.apiUrl+actionPrefix;
  },
  getAccessToken(){
    let access_token = authService.getAccessToken();
    return access_token;
  },
  postFile(action,data) {
    let _self=this;
    let url=_self.handleRequest(action);
    _self.requestHeaders.headers["Content-Type"]='multipart/form-data';  
    return _self.intercept(axios.post(url,data,_self.requestHeaders));
  },
  search(action,queryData) {
    let url = this.handleRequest(action+'?'+queryData);
    return this.intercept(axios.get(url,this.requestHeaders));
  },
  get(action) {
    let url=this.handleRequest(action);
    return this.intercept(axios.get(url,this.requestHeaders));
  },
  post(action,data) {
    let url=this.handleRequest(action);
    return this.intercept(axios.post(url,data,this.requestHeaders));
  },
  put(action,data) {
    let url=this.handleRequest(action);
    return this.intercept(axios.put(url,data,this.requestHeaders));
  },
  delete(action) {
    let url=this.handleRequest(action);
    return this.intercept(axios.delete(url, this.requestHeaders));
  },
  handleRequest(action) {
    let _self=this;
    _self.initHeaders();
    return _self.generateAPIUrl(action);;
  },
  generateAPIUrl(action){
    let _self=this;
    return `${_self.baseUrl}/${action}`;
  },
  initHeaders(){
    let _self=this;
    _self.requestHeaders={ headers: { 
        'Content-Type': 'application/json'
      }
    };
    let access_token=_self.getAccessToken();
    if(access_token)
      _self.requestHeaders.headers["Authorization"]=`${access_token}`;  
  },
  intercept(observable) {
    return observable.catch(error=>{
      var errorObj=new Error(error?error:'An error occurred at service level. Please try again later!!!')
      throw error;
    });
  },
}
